{
  "toast": {
    "masterAdministratorCreated": "Master administrator created",
    "customPlanCreatedOrganizationCanSubscribeOnSubscription": "Custom plan created — organization can subscribe on Subscription page",
    "timezoneAdded": "Timezone added",
    "currencyAdded": "Currency added",
    "taxModeAdded": "Tax mode added",
    "added": "Added",
    "testEmailSentCheckTheInboxAndSpam": "Test email sent — check the inbox (and spam folder)",
    "passwordChanged": "Password changed",
    "organizationUpdated": "Organization updated",
    "organizationCreated": "Organization created"
  },
  "errors": {
    "failedToLoadAnalytics": "Failed to load analytics",
    "failedToCreateMasterAdministrator": "Failed to create master administrator",
    "failedToLoadRequests": "Failed to load requests",
    "failedToCreatePlan": "Failed to create plan",
    "zoneIdAndLabelAreRequired": "Zone ID and label are required",
    "currencyCodeAndNameAreRequired": "Currency code and name are required",
    "decimalPlacesMustBeBetween0And4": "Decimal places must be between 0 and 4",
    "taxModeCodeAndNameAreRequired": "Tax mode code and name are required",
    "codeAndNameAreRequired": "Code and name are required",
    "failedToLoadReferenceData": "Failed to load reference data",
    "couldNotAddTimezone": "Could not add timezone",
    "couldNotAddCurrency": "Could not add currency",
    "couldNotAddTaxMode": "Could not add tax mode",
    "couldNotAddEntry": "Could not add entry",
    "enterARecipientEmailForTheTest": "Enter a recipient email for the test",
    "testEmailFailedSaveSmtpSettingsFirstThen": "Test email failed — save SMTP settings first, then retry",
    "failedToLoadPlatformSettings": "Failed to load platform settings",
    "failedToSaveSettings": "Failed to save settings",
    "failedToChangePassword": "Failed to change password",
    "orgCodeMustBe13UppercaseLetters": "Org code must be 1–3 uppercase letters or digits",
    "saveFailed": "Save failed",
    "failedToLoadPlans": "Failed to load plans",
    "failedToLoadMasterAdministrators": "Failed to load master administrators",
    "failedToLoadUsers": "Failed to load users",
    "failedToLoadOrganizations": "Failed to load organizations",
    "failedToLoad": "Failed to load"
  },
  "pages": {
    "platformAnalytics": "Platform Analytics",
    "platformInvoicesToday": "Platform Invoices Today",
    "salesToday": "Sales Today",
    "salesThisMonth": "Sales This Month",
    "masterAdministrators": "Master administrators",
    "newMasterAdministrator": "New master administrator",
    "platformOperatorsWhoCanAccessThe": "Platform operators who can access the master console",
    "customPlanRequests": "Custom plan requests",
    "reviewOrganizationRequestsAndPublishA": "Review organization requests and publish a private plan they can subscribe to.",
    "masterDashboard": "Master Dashboard",
    "totalOrganizations": "Total Organizations",
    "activeOrganizations": "Active Organizations",
    "activeSubscriptions": "Active Subscriptions",
    "todaySPlatformSales": "Today's Platform Sales",
    "todaySInvoices": "Today's Invoices",
    "monthSales": "Month Sales",
    "organizationMetrics": "Organization metrics",
    "platformWideOverview": "Platform-wide overview",
    "activeTenantsAndSubscriptions": "Active tenants and subscriptions",
    "referenceData": "Reference data",
    "globalCountriesCurrenciesTimezonesAndTax": "Global countries, currencies, timezones, and tax modes for tenant onboarding",
    "settings": "Settings",
    "security": "Security",
    "changePassword": "Change password",
    "general": "General",
    "ssoGoogleMicrosoft": "SSO (Google & Microsoft)",
    "emailSmtp": "Email (SMTP)",
    "rateLimiting": "Rate limiting",
    "platformConfigurationAccountSecurityAndMaster": "Platform configuration, account security, and master admin preferences.",
    "addAnExtraLayerOfProtection": "Add an extra layer of protection to your master account.",
    "useAStrongPasswordWithAt": "Use a strong password with at least 8 characters.",
    "frontendUrlCorsAndMfaIssuer": "Frontend URL, CORS, and MFA issuer.",
    "configureOauthProvidersForSingleSign": "Configure OAuth providers for single sign-on.",
    "outgoingMailForNotificationsAndPassword": "Outgoing mail for notifications and password resets.",
    "protectTheApiFromExcessiveRequest": "Protect the API from excessive request volume.",
    "platformUsers": "Platform users",
    "trackSignInAccountsAcrossAll": "Track sign-in accounts across all organizations and master operators",
    "organizations": "Organizations",
    "subscriptionPlans": "Subscription Plans",
    "subscriptions": "Subscriptions",
    "organizationSubscriptionStatusAcrossThePlatform": "Organization subscription status across the platform"
  },
  "labels": {
    "firstName": "First name *",
    "lastName": "Last name *",
    "email": "Email *",
    "password": "Password *",
    "planName": "Plan name",
    "monthlyPriceInr": "Monthly price (INR)",
    "yearlyPriceInr": "Yearly price (INR)",
    "maxStores": "Max stores",
    "maxEmployees": "Max employees",
    "maxProducts": "Max products",
    "description": "Description",
    "internalNotes": "Internal notes",
    "zoneIdIana": "Zone ID (IANA) *",
    "label": "Label *",
    "displayName": "Display name",
    "country": "Country",
    "region": "Region",
    "currencyCodeIso4217": "Currency code (ISO 4217) *",
    "name": "Name *",
    "symbol": "Symbol",
    "primaryCountry": "Primary country",
    "decimalPlaces": "Decimal places *",
    "isoNumericCode": "ISO numeric code",
    "taxModeCode": "Tax mode code *",
    "supportedTaxTypes": "Supported tax types",
    "code": "Code",
    "name2": "Name",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "loadingPlatformSettings": "Loading platform settings",
    "frontendUrl": "Frontend URL",
    "corsAllowedOriginsCommaSeparated": "CORS allowed origins (comma-separated)",
    "mfaIssuerName": "MFA issuer name",
    "oauthCallbackBaseUrl": "OAuth callback base URL",
    "clientId": "Client ID",
    "clientSecret": "Client secret",
    "fromEmail": "From email",
    "fromName": "From name",
    "smtpHost": "SMTP host",
    "port": "Port",
    "smtpUsername": "SMTP username",
    "smtpPassword": "SMTP password",
    "sendTestEmailTo": "Send test email to",
    "maxRequestsMinute": "Max requests / minute",
    "authEndpointsMaxMinute": "Auth endpoints max / minute",
    "accountType": "Account type",
    "orgCode": "Org code",
    "phone": "Phone",
    "gst": "GST",
    "city": "City",
    "eGFat": "e.g. FAT"
  },
  "formActions": {
    "publishPlan": "Publish plan"
  }
}
